import { AlertIcon } from '@/components/common/AlertIcon';
import { RequiredAsterisk } from '@/components/common/RequiredAsterisk';

export function FieldRow({ id, label, required, error, children }) {
  return (
    <div className="space-y-1.5">
      <label
        htmlFor={id}
        className="block text-sm font-semibold text-slate-700"
      >
        {label}
        {required && <RequiredAsterisk />}
      </label>
      {children}
      {error && (
        <p
          className="flex items-center gap-1.5 text-sm font-medium text-rose-700"
          role="alert"
        >
          <AlertIcon className="size-4 shrink-0" />
          {error}
        </p>
      )}
    </div>
  );
}